<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<dash-gis-flexible-panel [panelTitle]="reportTitle$ | async"
  [width]="panelWidth$ | async"
  [enableResize]="true"
  [disableHistory]="isHistoryEmpty$ | async"
  (panelBack)="historyBack()"
  (resizeEnd)="onResizeEnd($event)"
  (closePanel)="closePanel.emit()">
  <div class="dash-gis-data-report-display-container report-box" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
    @if (activeDataReports$ | async; as activeDataReports) {
      <div fxFlex fxLayout="column">
        <!-- multiple reports: single layer or data -->
        @if (activeDataReports.length > 1) {
          <dash-gis-report-selector
            [reportType]="'data'"
            [launchOptions]="activeDataReports"
            [uid]="uid"
            (recordCount)="setRecordCount($event)"
            (reportTitle)="setReportTitle($event)"
            fxFlex="1 1 auto"
          fxLayout="column"></dash-gis-report-selector>
        }
        <!-- single data report -->
        @if (activeDataReports.length === 1) {
          <dash-gis-data-report
            [launchOptions]="activeDataReports[0]"
            [showControls]="true"
            [uid]="uid"
            (recordCount)="setRecordCount($event)"
            (reportTitle)="setReportTitle($event)"
            fxFlex="1 1 auto"
          fxLayout="column"></dash-gis-data-report>
        }
      </div>
    }
  </div>
</dash-gis-flexible-panel>
